import { css } from '@emotion/react';
import { type ForwardedRef, forwardRef, type HTMLProps, memo } from 'react';

export type TruncateProps = Omit<HTMLProps<HTMLDivElement>, 'ref'> & {
  /** Show ellipsis or not. */
  isExpanded?: boolean;
  /** Max number of lines to display. */
  maxLines: number;
  /** CSS text-overflow. */
  textOverflow?: string;
};

export const TruncateBase = forwardRef(
  (
    { isExpanded = false, maxLines, textOverflow = 'ellipsis', ...props }: TruncateProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => (
    <div
      {...props}
      ref={ref}
      css={
        !isExpanded &&
        css`
          display: -webkit-box;
          -webkit-line-clamp: ${maxLines};
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ${textOverflow};
        `
      }
    />
  ),
);

TruncateBase.displayName = 'Truncate';

export const Truncate = memo(TruncateBase);
